import loadable from '@loadable/component';

import { withRouter } from 'react-router-dom';

const NotFoundPage = loadable(
  () => import(/* webpackChunkName:  "not-found-page" */ './NotFoundPage')
);

export default withRouter(NotFoundPage);
